import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import * as small_room from "./components/small-room";
import * as big_room from "./components/big-room";

const principle: Slide = {
  description: "A section of a bigger room with dimensions 18x18x9m (LxWxH).",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          items: [{ name: "Big room" }, { name: "Small room" }],
          options: {},
        },
      ],
      extraContent: [big_room.extraContent, small_room.extraContent],
      components: [big_room.component, small_room.component],
    },
  },
};

export default principle;
